import React from 'react';
const FacebookIcon = ({ width = 14, height = 25, style = {}, color = 'var(--facebook)', }) => (React.createElement("svg", Object.assign({}, { width, height, style }),
    React.createElement("title", null, 'facebook'),
    React.createElement("path", { d: "M4.067 24.889V13.757H0V9.333h4.067V5.848C4.067 2.06 6.592 0 10.277 0 12.043 0 13.56.122 14 .175v3.957h-2.556c-2.005 0-2.392.875-2.392 2.153v3.048h4.524l-.62 4.424H9.051v11.132", fill: color, fillRule: "nonzero" })));
export default FacebookIcon;
